import { InputType } from 'type-graphql'
import type { User } from '../user/User'

@InputType()
export abstract class ActionArgs {
  user?: User // injected from context, NOT input — no @Field()
}
